var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#2ACAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2917 40.6251L64.5834 33.3334M68.7501 29.1667L64.5834 33.3334L68.7501 29.1667ZM48.7293 49.1876C49.805 50.249 50.6601 51.5127 51.2454 52.9059C51.8307 54.2991 52.1347 55.7944 52.1397 57.3056C52.1448 58.8167 51.8509 60.314 51.2749 61.7111C50.6989 63.1082 49.8523 64.3776 48.7837 65.4462C47.7151 66.5148 46.4458 67.3614 45.0486 67.9374C43.6515 68.5134 42.1542 68.8073 40.6431 68.8022C39.1319 68.7972 37.6366 68.4932 36.2434 67.9079C34.8502 67.3226 33.5865 66.4675 32.5251 65.3917C30.4379 63.2307 29.2829 60.3363 29.309 57.3319C29.3351 54.3276 30.5402 51.4537 32.6647 49.3292C34.7891 47.2048 37.663 45.9997 40.6674 45.9736C43.6717 45.9475 46.5661 47.1024 48.7272 49.1897L48.7293 49.1876ZM48.7293 49.1876L57.2917 40.6251L48.7293 49.1876ZM57.2917 40.6251L63.5417 46.8751L70.8334 39.5834L64.5834 33.3334L57.2917 40.6251Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderLogin);
export default __webpack_public_path__ + "static/media/order_login.d27f8729774b2f860ea99f2bbc286519.svg";
export { ForwardRef as ReactComponent };